import _asyncToGenerator from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.includes.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import EntryBtn from './components/entry-btn.vue';
import RightMenu from './components/right-menu.vue';
import LeftContent from './components/left-content.vue';
import DrawerHeader from './components/drawer-header.vue';
import { expInfoBox } from '@/api/home.js';
export default {
  name: 'ExperienceContent',
  components: {
    RightMenu: RightMenu,
    LeftContent: LeftContent,
    EntryBtn: EntryBtn,
    DrawerHeader: DrawerHeader
  },
  data: function data() {
    return {
      menuVisible: true,
      mainVisible: false,
      // 书信息
      pdfurl: '',
      boxInfo: {},
      preciousType: 1,
      zipFileName: ''
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(['preciousMessage', 'experienceInfos', 'experienceBook', 'userActionZxbInfo', 'expandExperience'])), {}, {
    boxVisible: function boxVisible() {
      var _this$boxInfo, _this$boxInfo$boxCont, _this$boxInfo2, _this$boxInfo2$boxCov;

      return ((_this$boxInfo = this.boxInfo) === null || _this$boxInfo === void 0 ? void 0 : (_this$boxInfo$boxCont = _this$boxInfo.boxContentInfo) === null || _this$boxInfo$boxCont === void 0 ? void 0 : _this$boxInfo$boxCont.length) || ((_this$boxInfo2 = this.boxInfo) === null || _this$boxInfo2 === void 0 ? void 0 : (_this$boxInfo2$boxCov = _this$boxInfo2.boxCoverInfo) === null || _this$boxInfo2$boxCov === void 0 ? void 0 : _this$boxInfo2$boxCov.length) || this.preciousType === 4;
    }
  }),
  watch: {
    expandExperience: function expandExperience(val) {
      var _this = this;

      val && (this.mainVisible = val);

      if (val) {
        this.preciousType = 1;
        this.setHeader(1);
        setTimeout(function () {
          _this.getExpInfoBox();
        }, 800);
      }
    },
    preciousMessage: function preciousMessage(val) {
      this.preciousType = val.preciousType; // 只有1，2
    },
    preciousType: function preciousType(val) {
      if (val === 4) {
        this.$bus.$emit('toRightMenu', {
          preciousType: val
        });
        return;
      } // 智能学习系统不用请求书本信息


      if ([1, 2].includes(val) && val !== this.preciousMessage.preciousType) {
        this.setHeader(val);
      }

      this.getExpInfoBox();
    }
  },
  mounted: function mounted() {
    if (this.experienceInfos.preciousType) {
      this.preciousType = this.experienceInfos.preciousType;
    } // 默认展开


    this.$store.dispatch('setExpandExperience', true);
  },
  beforeDestroy: function beforeDestroy() {
    this.$store.dispatch('setExpandExperience', false);
  },
  methods: {
    setHeader: function setHeader(val) {
      var _this$userActionZxbIn;

      this.$store.dispatch('setPreciousMessage', _objectSpread(_objectSpread({}, this.preciousMessage), {}, {
        preciousType: val
      })); // 历史记录

      var subject = this.preciousMessage.subject;
      if (!subject) return;
      var zxbInfo = (_this$userActionZxbIn = this.userActionZxbInfo) !== null && _this$userActionZxbIn !== void 0 && _this$userActionZxbIn[subject] ? _objectSpread({}, this.userActionZxbInfo) : _defineProperty({}, subject, {
        box: {
          name: this.preciousMessage.boxName,
          preciousList: [{
            'name': '学习分册',
            'type': 1
          }, {
            'name': '练习分册',
            'type': 2
          }],
          boxId: this.preciousMessage.boxId
        }
      });
      zxbInfo[subject] = _objectSpread(_objectSpread({}, zxbInfo[subject]), {}, {
        precious: {
          'name': val === 1 ? '学习分册' : '练习分册',
          'type': val
        }
      });
      this.$store.dispatch('setPreciousInfo', zxbInfo);
    },
    handlerCloseExperience: function handlerCloseExperience() {
      this.mainVisible = false;
      this.$store.dispatch('setExpandExperience', false);
    },
    // 获取
    getExpInfoBox: function getExpInfoBox() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this2$preciousMessag;

        var params, _yield$expInfoBox, tempData, message;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if ((_this2$preciousMessag = _this2.preciousMessage) !== null && _this2$preciousMessag !== void 0 && _this2$preciousMessag.boxId) {
                  _context.next = 5;
                  break;
                }

                _this2.boxInfo = {};
                _this2.pdfurl = '';
                _this2.zipFileName = '';
                return _context.abrupt("return");

              case 5:
                params = {
                  preciousType: _this2.preciousType,
                  libraryId: _this2.experienceBook.libraryId,
                  boxId: _this2.preciousMessage.boxId
                };
                _context.next = 8;
                return expInfoBox(params);

              case 8:
                _yield$expInfoBox = _context.sent;
                tempData = _yield$expInfoBox.data;
                message = _yield$expInfoBox.message;
                _this2.pdfurl = tempData.pdfurl || '';
                _this2.boxInfo = tempData;
                _this2.zipFileName = tempData.zipFileName;

                if (!tempData.shelvesType) {
                  // 下架
                  _this2.$message.error(message || '体验产品已更新，请重新选择');

                  setTimeout(function () {
                    _this2.$router.push({
                      path: '/select'
                    });
                  }, 3000);
                }

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    } // 切换学习类型
    // handlerChangePeriousType(val) {
    //   this.preciousType = val
    //   if (val === 4) {
    //     this.$bus.$emit('toRightMenu', { preciousType: val })
    //     return
    //   } // 智能学习系统不用请求书本信息
    //   this.getExpInfoBox()
    // }

  }
};